
import { useScreen } from './hooks/useScreen';
import styles from './styles/AreaUnitChangeButton.module.css';

export type AreaUnitChangeButtonProps = {
  useMeterAreaUnit: boolean;
  onClick?: () => void;
};

export function AreaUnitChangeButton(props: AreaUnitChangeButtonProps) {
  const { useMeterAreaUnit } = props;
  const screenInfo = useScreen();
  const { isDesktop } = screenInfo;
  const containerClass = isDesktop ? styles.containerWide : styles.containerNarrow;

  return (
    <div className={styles.root}>
      <div className={containerClass}>
        <div className={styles.button} onClick={props.onClick}>
          <span className={styles.buttonText}>
            {useMeterAreaUnit ? `평 전환` : `㎡ 전환`}
          </span>
        </div>
      </div>
    </div>
  );
}
